<template>
  <div class="main_box">
    <div class="table_header">
      <div style="border: none;">床位号</div>
      <div>排队</div>
      <div>姓名</div>
      <div>治疗模式</div>
      <div>预约时间</div>
      <div>签到时间</div>
      <div>开始时间</div>
      <div>预下机时间</div>
    </div>
    <div class="table_body">
      <div class="row" v-for="item in displayData" :key="item.id">
        <div style="border: none;">{{ item.bed_nm }}</div>
        <div>{{ item.task_sort_sign }}</div>
        <div>{{ maskName(item.psn_nm) }}</div>
        <div>{{ item.hdt_flg }}</div>
        <div>{{ item.add_yy_time }}</div>
        <div>{{ item.task_tm_signin | formatting }}</div>
        <div>{{ item.task_tm_start | formatting }}</div>
        <div>{{ item.add_xj_time }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'Table',
  props: {
    patData: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    formatting(value) {
      if (!value) return '';
      return dayjs(value).format('HH:mm');
    }
  },
  data() {
    return {
      patList: [],//原始数据
      pageSize: 0,// 每页可容纳的行数
      displayData: [],// 最终展示的数据
      cycleTimer: null,// 定时器实例（用于清理）
      currentIndex: 0, // 当前显示数据的索引
    }
  },
  mounted() {
    // 设置定时器，每隔十秒显示下一批数据
    this.cycleTimer = setInterval(this.showNextData, 5000);
  },
  methods: {
    // 姓名脱敏
    maskName(value) {
      if (value) {
        if (value.length === 2) {
          return value.substring(0, 1) + "*"; // 两个字的最后一个字符用*替换
        } else if (value.length === 3) {
          return value.substring(0, 1) + '*' + value.substring(2); // 三个字的将中间的字替换为*
        } else if (value.length > 3) {
          return value.substring(0, 1) + '*'.repeat(value.length - 2) + value.substring(value.length - 1); // 三个字以上的保留首尾两个字，其它的替换为*
        } else {
          return value; // 一个字的姓名不进行处理
        }
      }
    },
    getDivHeightByClassName() {
      if (this.patData.length === 0) {
        console.log('patData为空，无需获取row元素高度');
        return;
      }

      const targetElement1 = document.querySelector('.main_box');
      const targetElement2 = document.querySelector('.table_header');
      const targetElement3 = document.querySelector('.row');

      if (!targetElement1) {
        console.warn('未找到类名为 main_box 的元素');
        return;
      }
      if (!targetElement2) {
        console.warn('未找到类名为 table_header 的元素');
        return;
      }
      if (!targetElement3) {
        console.warn('未找到类名为 row 的元素');
        return;
      }

      // 获取不同维度的高度（按需选择）
      const clientHeight1 = targetElement1.clientHeight;
      const clientHeight2 = targetElement2.clientHeight;
      const clientHeight3 = targetElement3.clientHeight;

      let patListH = clientHeight1 - clientHeight2;
      console.log('patListH：', patListH);
      console.log('可容纳row数量：', (patListH / clientHeight3) - 1);
      this.pageSize = parseInt((patListH / clientHeight3) - 1)
      for (let i = 0; i < this.pageSize; i++) {
        this.displayData.push(this.patList[i])
      }
      this.currentIndex = this.pageSize

      this.showNextData()
    },
    showNextData() {
      // 切片获取下一批数据
      // console.log(this.pageSize);

      this.displayData = this.patList.slice(
        this.currentIndex,
        this.currentIndex + this.pageSize
      );
      // 更新索引
      this.currentIndex += this.pageSize;
      // 如果已经显示完所有数据，从头开始显示
      if (this.currentIndex >= this.patList.length) {
        this.currentIndex = 0;
      }
    }
  },
  watch: {
    patData: {
      immediate: true, // 组件初始化时立即执行一次
      handler(newVal) {
        if (newVal.length > 0) {
          this.patList = newVal
          this.displayData.push(newVal[0])
          console.log(this.displayData);

          // 核心修改：使用$nextTick确保DOM更新完成后再获取元素
          this.$nextTick(() => {
            this.getDivHeightByClassName();
          });
        }
      }
    }
  },
  beforeDestroy() {
    if (this.cycleTimer) {
      clearInterval(this.cycleTimer);
      this.cycleTimer = null;
    }
  },
}
</script>

<style scoped>
.main_box {
  height: 100%;
  width: 100%;
}

.main_box .table_header {
  width: 100%;
  height: 0.7rem;
  background-color: var(--color-primary-light-5);
  border-radius: 0.1rem;
  display: flex;
  align-items: center;
  font-size: 0.35rem;
  color: #ffffff;
}

.main_box .table_header div {
  flex: 1;
  text-align: center;
  font-weight: bold;
  border-left: 0.05rem solid #ffffff;
}

.main_box .table_body {
  width: 100%;
  height: calc(100% - 0.8rem);
  font-size: 0.35rem;
  margin-top: 0.1rem;
}

.main_box .table_body .row {
  width: 100%;
  display: flex;
  align-items: center;
  background-color: var(--color-primary-light-5);
  border-bottom: 0.02rem solid #ffffff;
  color: #ffffff;
}

.main_box .table_body .row div {
  flex: 1;
  height: 0.7rem;
  border-left: 0.05rem solid #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>